module.exports = __webpack_public_path__ + "static/media/virtual-appraisal.bfaec148.svg";